import { createBrowserRouter, Navigate, type RouteObject } from "react-router-dom";

import { isDevBuild } from "@/config/env";
import AccountSettingPage from "@/features/settings/account/AccountSettingPage";
import ChangeAddressConfirmPage from "@/features/settings/account/ChangeAddressConfirmPage";
import ChangeAddressErrorPage from "@/features/settings/account/ChangeAddressErrorPage";
import ChangeAddressPage from "@/features/settings/account/ChangeAddressPage";
import ChangeAddressSuccessPage from "@/features/settings/account/ChangeAddressSuccessPage";
import DocumentAddressContractPage from "@/features/settings/account/DocumentAddressContractPage";
import InputPinPage from "@/features/settings/account/InputPinPage";

import { AppLayout } from "./AppLayout";
import { ROUTES } from "./routes";

function NotFoundPage() {
  return (
    <main className="safe-top px-4 py-4">
      <p className="text-16">ไม่พบหน้าที่ต้องการ</p>
    </main>
  );
}

/**
 * The dev sign-in and diagnostics pages, loaded on demand. `isDevBuild` is a
 * compile-time constant, so a production build drops this branch and never
 */
const devRoutes: RouteObject[] = isDevBuild
  ? [
      {
        path: "/dev/login",
        lazy: async () => ({
          Component: (await import("@/dev/DevLoginPage")).default,
        }),
      },
      {
        path: "/dev/diagnostics",
        lazy: async () => ({
          Component: (await import("@/features/diagnostics/DiagnosticsPage"))
            .default,
        }),
      },
    ]
  : [];

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: isDevBuild ? (
          <Navigate to={ROUTES.dev.login} replace />
        ) : (
          <NotFoundPage />
        ),
      },
      {
        path: ROUTES.settings.root,
        children: [
          { index: true, element: <Navigate to={ROUTES.settings.account} replace /> },
          { path: ROUTES.settings.account, element: <AccountSettingPage /> },
          { path: ROUTES.settings.accountInputPin, element: <InputPinPage /> },
          {
            path: ROUTES.settings.accountDocumentAddress,
            element: <DocumentAddressContractPage />,
          },
          {
            path: ROUTES.settings.accountChangeAddress,
            element: <ChangeAddressPage />,
          },
          {
            path: ROUTES.settings.accountChangeAddressConfirm,
            element: <ChangeAddressConfirmPage />,
          },
          {
            path: ROUTES.settings.accountChangeAddressSuccess,
            element: <ChangeAddressSuccessPage />,
          },
          {
            path: ROUTES.settings.accountChangeAddressError,
            element: <ChangeAddressErrorPage />,
          },
        ],
      },
      ...devRoutes,
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
